import { Injectable } from '@angular/core';
import { BoardSummary } from 'app/trello/models/board-summary';
import { BoardSummaryMapperAsync } from 'app/trello/services/board-summary-mapper-async';
import { BoardSummaryMapperSync } from 'app/trello/services/board-summary-mapper-sync';
import { environment } from 'environments/environment';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BoardSummaryMapper {

  constructor(
    private readonly boardSummaryMapperAsync: BoardSummaryMapperAsync,
    private readonly boardSummaryMapperSync: BoardSummaryMapperSync,
  ) {
  }

  public map(
    boardSummary: BoardSummary,
  ): Observable<BoardSummary> {

    if (!boardSummary.cards) {

      // no cards to map ...
      return of(boardSummary);
    }

    const useWorker =
      environment.features.webworkers
      && typeof Worker !== 'undefined';

    if (useWorker) {
      return this.boardSummaryMapperAsync.map(boardSummary);

    } else {
      return of(this.boardSummaryMapperSync.map(boardSummary));
    }
  }

}
